import React from "react";
import IFetchApi from "./IFetchApi";

const FetchApiCtx: React.Context<IFetchApi> = React.createContext(undefined as any as IFetchApi);

export default FetchApiCtx;